import styled from "styled-components";
import uiButton from "components/ui/Button";

export const NavigationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 32px 0 50px 0;
`;

export const Button = styled(uiButton)`
  svg {
    position: relative;
    top: -1px;
  }
`;
